module.exports = __webpack_public_path__ + "img/sys3-select.21ff9c15.png";